import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import statistics from '@/components/statistics' //首页统计
import userCenter from "@/components/userCenter" //用户中心
import usage from "@/components/usage" //使用情况
import pricingCenter from "@/components/pricingCenter" //算价中心
import activationCode from "@/components/activationCode" //激活码管理
import workOrder from "@/components/workOrder" //工单管理列表
// import chinamap from "@/components/chinamap" //工单管理列表
// chinamap
Vue.use(Router)

//获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children:[
        {
          path:'/',
          name:'statistics',
          component:statistics
        },
        {
          path:'/userCenter',
          name:'userCenter',
          component:userCenter
        },
        {
          path:'/usage',
          name:'usage',
          component:usage
        },
        {
          path:'/pricingCenter',
          name:'pricingCenter',
          component:pricingCenter
        },
        {
          path:'/activationCode',
          name:'activationCode',
          component:activationCode
        },
        {
          path:'/workOrder',
          name:'workOrder',
          component:workOrder
        }
      ]
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
  ]
})
router.beforeEach((to,from,next)=>{
  if(to.path == '/Login'){
    next()
  }else {
    let token = localStorage.getItem('token')
    token ? next() : next('/Login')
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js